import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSkipNextTriangleStyle0 = cosmosIconCss;

const CosmosIconSkipNextTriangle$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipNextTriangle extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fb800fc33b482ebc74fb3617c5ae201bb58f4a43', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cc914e59dff56cb785be563c61904714db0fe264', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fecf4995ffd6adc0bc79ea7efb919167e4aec3d1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.1 11.44-8.38 5A.5.5 0 0 1 5 16V6a.49.49 0 0 1 .72-.46l8.38 5a.5.5 0 0 1 0 .9ZM16.5 6h1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSkipNextTriangleStyle0; }
}, [1, "cosmos-icon-skip-next-triangle", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-next-triangle"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-next-triangle":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipNextTriangle$1);
            }
            break;
    } });
}

const CosmosIconSkipNextTriangle = CosmosIconSkipNextTriangle$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipNextTriangle, defineCustomElement };
